import {RegionModel} from './RegionModel';
import {LocalCustomerModel} from './LocalCustomerModel';
import {ResourcesUnitModel} from './ResourcesUnitModel';
import {ContractTypeModel} from './ContractTypeModel';
import {ProviderModel} from './ProviderModel';
import {ServiceVariantModel} from './ServiceVariantModel';

export class ConsuntivoChargesModel {
  id: number;
  numAnnoMese: number;
  numAnnoMeseRif: number;
  region: RegionModel;
  localCustomer: LocalCustomerModel;
  contractType: ContractTypeModel;
  resourceUnit: ResourcesUnitModel;
  serviceVariant: ServiceVariantModel;
  provider: ProviderModel;
  isRecovery: number;
  charge: number;
  numAnnoMeseAcceptance: number;
  residualMonth: number;
  percUse: number;
  notes: string;

  constructor(id?: number,
              numAnnoMese?: number,
              numAnnoMeseRif?: number,
              region?: RegionModel,
              localCustomer?: LocalCustomerModel,
              resourceUnit?: ResourcesUnitModel,
              contractType?: ContractTypeModel,
              serviceVariant?: ServiceVariantModel,
              provider?: ProviderModel,
              isRecovery?: number,
              charge?: number,
              numAnnoMeseAcceptance?: number,
              residualMonth?: number,
              percUse?: number,
              notes?: string) {
    this.id = id;
    this.numAnnoMese = numAnnoMese;
    this.numAnnoMeseRif = numAnnoMeseRif;
    this.region = region;
    this.localCustomer = localCustomer;
    this.resourceUnit = resourceUnit;
    this.contractType = contractType;
    this.serviceVariant = serviceVariant;
    this.provider = provider;
    this.isRecovery = isRecovery;
    this.charge = charge;
    this.numAnnoMeseAcceptance = numAnnoMeseAcceptance;
    this.residualMonth = residualMonth;
    this.percUse = percUse;
    this.notes = notes;
  }
}
